/**
 * Use assert() to assert state which your program assumes to be true.
 * Error messages and checks will be stripped in production.
 */

function assert(condition, message) {
  if (process.env.NODE_ENV !== 'production') {
    if (!condition) {
      console.error('Assertion failed', message); // eslint-disable-line
      throw new Error(`Assertion error: ${message}`);
    }
  }
}
export const makeAssert = messagePrefix => (condition, message) => {
  assert(condition, `${messagePrefix} ${message}`);
};
export default assert;